import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BaseService } from '.';
import { OperatorService } from './operator.service';

@Injectable({
  providedIn: 'root'
})
export class OperatorResolverService  {

  constructor(private operatorService: OperatorService, private baseService: BaseService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    this.baseService.loaderSource.next(true)
    // this.baseService.loaderSource.subscribe(val=>{
    //   console.log(val);
    // })
    return this.operatorService.getOperators().then(data => {
      this.baseService.loaderSource.next(false)
      if (data) {
        return data;
      } else {
        return;
      }
    });
  }
}
